import BaseModel from 'base/model/base_model'

export default BaseModel.extend({
  constructor: function LetterPaperModel() {
    BaseModel.apply(this, arguments)
  },

  props: {
    printSender: ['boolean', true, true],
    printHeader: ['boolean', true, true],
    printFooter: ['boolean', true, true],
    infoBlockPosition: ['object'],
    addressBlockPosition: ['object'],
  },
})
